import { Role } from '../roles'

export default {
  [Role.RootAdmin]: 'Super Admin',
  [Role.Admin]: 'Administrator',
  [Role.Sales]: 'User',
  [Role.Client]: 'Client',
}
